import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Sling as Hamburger } from "hamburger-react";
import { scaleChar } from "./animatedtitle";
import { motion } from "framer-motion";
import { IoCloseOutline, IoMenuOutline } from "react-icons/io5";
import { CgMenuRight } from "react-icons/cg";
import { VscClose } from "react-icons/vsc";

class Navbar extends Component {
  state = {
    clicked: false,
  };

  buttonClick = () => {
    this.setState((prevState) => ({
      clicked: !prevState.clicked,
    }));
  };

  closeMenu = () => {
    this.setState(() => ({
      clicked: false,
    }));
  };

  render() {
    return (
      <div className="w-full max-w-screen-2xl fixed z-50">
        <header className="transition-all bg-[#171717] py-0 px-[20px] sm:px-6 lg:px-10 flex justify-between items-center ease-in duration-300 h-20">
          <div>
            <Link onClick={this.closeMenu} to="/">
              <h2 className="font-[600] text-white text-xl">shadrxcc.</h2>
            </Link>
          </div>
          <nav>
            <ul
              id="navbar"
              className={`${
                this.state.clicked ? "#navbar active" : "#navbar"
              } bg-[#171717] text-white text-lg flex flex-col mt-[15em] gap-[2em] md:mt-0 items-center md:bg-inherit bg-[rgba(23, 23, 23)] w-[100%] right-[0px] h-[100vh] md:h-0 fixed md:relative md:top-0 top-[-100em] md:flex-row`}
            >
              <Link to="/projects" onClick={this.closeMenu}>
                <motion.li
                  className="active text-white"
                  whileHover={() => scaleChar()}
                >
                  Projects
                </motion.li>
              </Link>
              <Link to="/about" onClick={this.closeMenu}>
                <motion.li
                  className="active text-white"
                  whileHover={() => scaleChar()}
                >
                  About
                </motion.li>
              </Link>
              <Link to="/contact" onClick={this.closeMenu}>
                <motion.li
                  className="active text-white"
                  whileHover={() => scaleChar()}
                >
                  Contact
                </motion.li>
              </Link>
            </ul>
          </nav>
          <div
            className="mobile transition-all  ease-in duration-300 md:hidden"
            onClick={() => {
              this.buttonClick();
            }}
          >
            {this.state.clicked ? (
              <VscClose
                className={`${
                  this.state.clicked ? "transition-all rotate-90" : ""
                } text-white text-3xl menu-icon`}
              />
            ) : (
              <CgMenuRight className="text-white transition-all ease-in-out duration-300 text-3xl menu-icon" />
            )}

            {/* <Hamburger color="#fff" size={24} rounded /> */}
          </div>
        </header>
      </div>
    );
  }
}

export default Navbar;
